import { enableProdMode, Injector } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
// import { Router } from "@angular/router";
// import { downgradeInjectable, UpgradeModule } from "@angular/upgrade/static";
import { TCIAppMessaging } from "@tci/common";
// import { IAngularStatic } from "angular";

import { NgAppModule } from "./app/ng-app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// declare var angular: IAngularStatic;

/**
 * ng1Services is the bridge between ng1 and ng2
 */
(<any>window).ng1Services = {};

/* DO NOT remove this `export default`. It is to make sure this file is included in the transpiled `index.js` file. */
platformBrowserDynamic()
  .bootstrapModule(NgAppModule)
  // .then((platformRef) => {
    // const injector: Injector = platformRef.injector;
    // const upgrade = injector.get(UpgradeModule) as UpgradeModule;
    // const appMessaging = injector.get("ngAppMessaging") as TCIAppMessaging;

    // angular
    //   .module("main")
    //   .factory("eventService", downgradeInjectable("ngAppMessaging") as any);

    // upgrade.bootstrap(document.body, [
    //   "main"
    // ]);

    // appMessaging.emit("NG1_BOOTSTRAP_COMPLETE", (<any>window).ng1Services);

    // setTimeout(function () {
    //   injector
    //     .get(Router)
    //     .initialNavigation();
    // });
  // })
  .catch(oError => console.log(oError));

export const __placeholder__ = {};
